export default __webpack_public_path__ + "static/media/boy.fe5a3ef1.png";